import { notification } from 'ant-design-vue';

export const notice = (type, string, description, { placement = 'topRight', top = '24px', duration = 4.5 } = {}) => {
  notification[type]({
    message: string,
    description: description,
    placement,
    top,
    duration
  })
}